import type { ChecklistSaveInput } from "cadendar-shared";

export type ChecklistEditorAction =
  | { type: "name"; name: string }
  | { type: "add"; id: string }
  | { type: "remove"; id: string }
  | { type: "move"; id: string; direction: -1 | 1 };

export function checklistEditorReducer(
  state: ChecklistSaveInput,
  action: ChecklistEditorAction,
) {
  if (action.type === "name") return { ...state, name: action.name };
  if (action.type === "add") {
    return state.materialIds.includes(action.id)
      ? state
      : { ...state, materialIds: [...state.materialIds, action.id] };
  }
  if (action.type === "remove")
    return {
      ...state,
      materialIds: state.materialIds.filter((id) => id !== action.id),
    };
  const index = state.materialIds.indexOf(action.id);
  const destination = index + action.direction;
  if (index < 0 || destination < 0 || destination >= state.materialIds.length)
    return state;
  const materialIds = [...state.materialIds];
  [materialIds[index], materialIds[destination]] = [
    materialIds[destination],
    materialIds[index],
  ];
  return { ...state, materialIds };
}
